Object.defineProperty(exports, "__esModule", { value: true });
exports.basicStyles = {
    container: {
        position: 'relative',
        display: 'flex',
        width: '100%'
    },
    frame: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        borderWidth: '0 !important',
        outline: '1px solid #666'
    },
    slidesPanel: {
        display: 'inline-flex',
        position: 'relative'
    },
    counterBlock: {
        position: 'absolute'
    },
    leftArrow: {
        width: '20px',
        height: '50px',
        border: '1px solid #888',
        backgroundColor: '#888',
        cursor: 'pointer'
    },
    leftArrowDisabled: {
        extend: 'leftArrow'
    },
    rightArrow: {
        width: '20px',
        height: '50px',
        border: '1px solid #888',
        backgroundColor: '#888',
        cursor: 'pointer'
    },
    rightArrowDisabled: {
        extend: 'rightArrow'
    },
};
